import {Route} from "react-router-dom";
import {lazy} from "react";
import UrlsConfig from "@/config/UrlsConfig";

const UserProfileView = lazy(() => import("@/pages/ControlPanel/Nested/Users/UserProfileView"));
const EditUser = lazy(() => import("@/pages/ControlPanel/Nested/Users/EditUser"));
const CreateUser = lazy(() => import("@/pages/ControlPanel/Nested/Users/CreateUser"));

const urlsConfig = new UrlsConfig();

export function usersRoutes() {
    return (
      <>
          <Route path={`${urlsConfig.users.to}/:userId`} element={<UserProfileView/>}/>
          <Route path={`${urlsConfig.inControlPanelEditUser.to}/:userId`} element={<EditUser/>}/>
          <Route path={urlsConfig.inControlPanelCreateUser.to} element={<CreateUser/>}/>
      </>
    );
}
